import { render, staticRenderFns } from "./FloatAccountsBalance.vue?vue&type=template&id=6e85a0f0&"
import script from "./FloatAccountsBalance.vue?vue&type=script&lang=js&"
export * from "./FloatAccountsBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports